/**
 * Canonical analytics event names.
 *
 * Convention: `lyt-<domain>-<action>` (kebab-case, verb-last).
 *
 * These names are shared across both analytics channels — GA4 custom events
 * and Microsoft Clarity beacons — via `trackEvent` from `src/utils/analytics.js`.
 * GA4 requires event names in kebab/snake case so this shape is authoritative.
 */
const ANALYTIC_EVENTS = {
    // Map Search Events
    MAP_SEARCH_FOCUSED: 'lyt-map-search-focus',
    MAP_SEARCH_ITEM_SELECTED: 'lyt-map-search-item-select',

    // Map Interaction Events
    MAP_VEHICLE_CLICKED: 'lyt-map-vehicle-click',
    MAP_SIGNAL_CLICKED: 'lyt-map-signal-click',
    MAP_VEHICLE_HOVERED: 'lyt-map-vehicle-hover',
    MAP_SIGNAL_HOVERED: 'lyt-map-signal-hover',
    MAP_PRIORITY_CLICKED: 'lyt-map-priority-click',
    MAP_PRIORITY_HOVERED: 'lyt-map-priority-hover',
    MAP_RAIL_TSP_HOVERED: 'lyt-map-rail-tsp-hover',
    MAP_EVP_VEHICLE_CLICKED: 'lyt-map-evp-vehicle-click',
    MAP_EVP_INCIDENT_CLICKED: 'lyt-map-evp-incident-click',

    // Dashboard Interaction Events
    DASHBOARD_TIME_PERIOD_CHANGED: 'lyt-dashboard-time-period-change',
    DASHBOARD_DATE_RANGE_SELECTED: 'lyt-dashboard-date-range-select',
    DASHBOARD_DATA_EXPORTED: 'lyt-dashboard-data-export',
    DASHBOARD_CHART_FILTER_CHANGED: 'lyt-dashboard-chart-filter-change',
    DASHBOARD_NAVIGATION_CLICKED: 'lyt-dashboard-navigation-click',
    DASHBOARD_ALERT_CLICKED: 'lyt-dashboard-alert-click',
    DASHBOARD_ALERT_STATUS_CHANGED: 'lyt-dashboard-alert-status-change',
    DASHBOARD_CHART_LEGEND_CLICKED: 'lyt-dashboard-chart-legend-click',
    DASHBOARD_WIDGET_TOGGLED: 'lyt-dashboard-widget-toggle',
    DASHBOARD_ERROR_BOUNDARY_TRIGGERED: 'lyt-dashboard-error-boundary-trigger',
    DASHBOARD_CHART_REFRESHED: 'lyt-dashboard-chart-refresh',
};

export default ANALYTIC_EVENTS;